import { authClient } from '@/app/_auth/auth-client'

export function signOutFromBaza() {
  void authClient.signOut({
    fetchOptions: {
      onSuccess: () => {
        window.location.href = '/baza'
      }
    }
  })
}
